module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA5klEQVQ4T82S20rEMBiEZwrCIiQvY8ELDzSRRRBlfSGhr6S7XixCUjyAQp+mBfGqI5EWCsJ2l73Z3ITAZJhv/p/Y83DP/zhAgxDCGcnSGLPI8/w7IdZ1fdw0zTLLsrIoircx9j+EGOMSwK2kV5LXvfgFwLmkJ+/9YspgJmlN8hLAWtIRSQ/gHcDcOfez0WAUOSU4SW9JX9ZaPyBtaxBInvbiT2PM1VYGMcYZgD/m/k4e86GTSYQQwjPJm4G5Rxg6eXTO3W9EqKrqouu60lp7Nx5j27YrSQ/e+4/JDnZZ7wNc5V3iJ+0v8RJjEWQXxnQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./component/queryform/reset-icon.png
// module id = 206
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27